export default "__VITE_ASSET__D_0GOTep__"